import { $themeConfig } from '@themeConfig'
import store from '@/store'
import myProfile from '@/router/routes/home/my-profile'
import home from '@/router/routes/home/home'
import statistic from '@/router/routes/home/statistic'
import emptyPage from '@/router/routes/home/empty-page'

import ministry from '@/router/routes/home/ministry'

const { staticModule } = store.state
/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return store.getters['auth/isAuthenticated']
}

export const getUserData = () => store.state.auth.user ?? {}

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeForLoggedInUser = userRole => {
  switch (userRole) {
    case staticModule.roleApplicant:
      return myProfile
    case staticModule.roleUniversity:
      return statistic
    case staticModule.roleInnovation:
      return home
    case staticModule.roleMinistry:
      return ministry
    default:
      return emptyPage
  }
}

export const getHomePageTitle = () => {
  const userData = getUserData()
  const route = getHomeForLoggedInUser(userData.role_id ?? null)
  return route[0].meta.pageTitle
}

export const getAppTitle = () => {
  const userData = getUserData()
  const userRole = userData.role_id ?? null
  if (userRole) {
    return store.getters['staticModule/getUserRole'](userRole).name
  }
  return $themeConfig.app.appName
}

export const getHomeRouteForLoggedInUser = () => ({ name: 'home' })

export const isOrganization = () => {
  const userData = getUserData()
  const userRole = userData.role_id ?? null
  return [staticModule.roleInnovation, staticModule.roleUniversity, staticModule.roleMinistry, staticModule.roleFinance].includes(userRole)
}

export const isRoleUniversity = () => {
  const userData = getUserData()
  const userRole = userData.role_id ?? null
  return [staticModule.roleUniversity].includes(userRole)
}

export const isApplicant = () => {
  const userData = getUserData()
  const userRole = userData.role_id ?? null
  return staticModule.roleApplicant === userRole
}

export const isAdmin = () => {
  const userData = getUserData()
  const userRole = userData.role_id ?? null
  return staticModule.roleInnovation === userRole
}

export const isOrgHead = () => {
  const userData = getUserData()
  const userRole = userData.role_id ?? null
  return staticModule.roleOrgHead === userRole
}

export const getRoleSettingsComponent = () => {
  if (isOrganization()) return 'organization-settings'
  return 'empty-page'
}
export const myOrganization = () => getUserData().org_id
